export function getDynamicValue<T extends Record<string, any>>(obj: T, key: keyof T | string): T[keyof T] | undefined {
    return key in obj ? obj[key as keyof T] : undefined;
}
